import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../../components/calendar/Calendar";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";
import Autocomplete from '../../../../../../components/autocomplete/Autocomplete';
import Utils from "../../../../../../utils/Utils";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";


class DatiAnagraficiPaziente extends Component {


    state = {
        datiAnagraficiPaziente: {
            cognomePaziente: "",
            nomePaziente: "",
            sesso: "",
            statoGravidanza: "",
            comuneResidenza: "",
            dataNascitaPaziente: "",
            anniCompiuti: "",
            mesiCompiuti: "",
            meseGestazione: "",
            corretto: []
        },
        comuni: JSON.parse(sessionStorage.getItem("comuni")),
        comuniPerCodice: JSON.parse(sessionStorage.getItem("comuniPerCodice")),
        listaNazioni: JSON.parse(sessionStorage.getItem("nazioni")),
        nazioniPerCodice: JSON.parse(sessionStorage.getItem("nazioniPerCodice")),
    }

    constructor(props) {
        super(props);

        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.controllaDati = this.controllaDati.bind(this)
        this.createJsonForBackend = this.createJsonForBackend.bind(this)
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiPaziente) {
            let datiAnagraficiPaziente = this.state.datiAnagraficiPaziente
            let datiProps = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.datiAnagraficiPaziente))
            datiAnagraficiPaziente.cognomePaziente = datiProps.cognomePaziente ? datiProps.cognomePaziente : this.props.datiPaziente.cognomePaziente
            datiAnagraficiPaziente.nomePaziente = datiProps.nomePaziente ? datiProps.nomePaziente : this.props.datiPaziente.nomePaziente
            datiAnagraficiPaziente.sesso = datiProps.sesso ? datiProps.sesso : this.props.datiPaziente.sesso
            datiAnagraficiPaziente.statoGravidanza = datiProps.statoGravidanza ? datiProps.statoGravidanza : ""
            datiAnagraficiPaziente.comuneResidenza = datiProps.comuneResidenza ? this.state.comuniPerCodice[datiProps.comuneResidenza] ? this.state.comuniPerCodice[datiProps.comuneResidenza] : this.state.nazioniPerCodice[datiProps.comuneResidenza] ? this.state.nazioniPerCodice[datiProps.comuneResidenza] : "" : this.state.comuniPerCodice[this.props.datiPaziente.comuneResidenza.codice] ? this.state.comuniPerCodice[this.props.datiPaziente.comuneResidenza.codice] : this.state.nazioniPerCodice[this.props.datiPaziente.comuneResidenza.codice] ? this.state.nazioniPerCodice[this.props.datiPaziente.comuneResidenza.codice] : ""
            datiAnagraficiPaziente.dataNascitaPaziente = datiProps.dataNascitaPaziente ? datiProps.dataNascitaPaziente : this.props.datiPaziente.dataDiNascita
            datiAnagraficiPaziente.anniCompiuti = datiProps.anniCompiuti ? datiProps.anniCompiuti : ""
            datiAnagraficiPaziente.mesiCompiuti = datiProps.mesiCompiuti ? datiProps.mesiCompiuti : ""
            datiAnagraficiPaziente.meseGestazione = datiProps.meseGestazione ? datiProps.meseGestazione : ""
            this.setState({datiAnagraficiPaziente: datiAnagraficiPaziente})
        } else {
            let datiPazienteProps = this.props.datiPaziente
            let datiAnagraficiPaziente = this.state.datiAnagraficiPaziente
            datiAnagraficiPaziente.nomePaziente = datiPazienteProps.nomePaziente
            datiAnagraficiPaziente.cognomePaziente = datiPazienteProps.cognomePaziente
            datiAnagraficiPaziente.dataNascitaPaziente = datiPazienteProps.dataDiNascita
            datiAnagraficiPaziente.sesso = datiPazienteProps.sesso
            datiAnagraficiPaziente.comuneResidenza = datiPazienteProps.comuneResidenza ? this.state.comuniPerCodice[datiPazienteProps.comuneResidenza.codice] ? this.state.comuniPerCodice[datiPazienteProps.comuneResidenza.codice] : this.state.nazioniPerCodice[datiPazienteProps.comuneResidenza.codice] ? this.state.nazioniPerCodice[datiPazienteProps.comuneResidenza.codice] : "" : this.state.comuniPerCodice[this.props.datiPaziente.comuneResidenza.codice] ? this.state.comuniPerCodice[this.props.datiPaziente.comuneResidenza.codice] : this.state.nazioniPerCodice[this.props.datiPaziente.comuneResidenza.codice] ? this.state.nazioniPerCodice[this.props.datiPaziente.comuneResidenza.codice] : ""
            datiAnagraficiPaziente.anniCompiuti = datiPazienteProps.eta
            datiAnagraficiPaziente.mesiCompiuti = datiPazienteProps.mesi
            this.setState({datiAnagraficiPaziente: datiAnagraficiPaziente})
        }

        this.controllaDati();
        this.props.setDatiAnagraficiPaziente(this.state.datiAnagraficiPaziente)

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.controllaDati();

        if (prevState !== this.state) {
            let obj = this.createJsonForBackend();
            this.props.setDatiAnagraficiPaziente(this.state.datiAnagraficiPaziente, this.validate(), obj)
        }
    }

    validate() {

        if (this.state.datiAnagraficiPaziente.dataNascitaPaziente) {
            let validatedataNascitaPaziente = Utils.checkDateInterval(this.state.datiAnagraficiPaziente.dataNascitaPaziente, "31/12/1899");
            let validatedataNascitaPazienteOdierna = Utils.checkDateInterval(this.state.datiAnagraficiPaziente.dataNascitaPaziente, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataNascitaPaziente) {
                return "Messages.DataNascita"
            } else if (!validatedataNascitaPazienteOdierna) {
                return "Messages.DataNascitaOdierna"
            }
        }

        if (this.state.datiAnagraficiPaziente.mesiCompiuti > 12) {
            return "Messages.ERR_01_02_0C_0U"
        }

        return ""

    }

    createJsonForBackend() {
        let dati = this.state.datiAnagraficiPaziente
        let ObjectForBackEnd = {}
        ObjectForBackEnd["cognomePaziente"] = dati.cognomePaziente
        ObjectForBackEnd["nomePaziente"] = dati.nomePaziente
        ObjectForBackEnd["sesso"] = dati.sesso
        ObjectForBackEnd["statoGravidanza"] = dati.statoGravidanza
        if (dati.comuneResidenza && dati.comuneResidenza.codice) {
            ObjectForBackEnd["comuneResidenza"] = dati.comuneResidenza.codice
        } else
            ObjectForBackEnd["comuneResidenza"] = this.props.datiPaziente.comuneResidenza.codice
        ObjectForBackEnd["dataNascitaPaziente"] = dati.dataNascitaPaziente
        ObjectForBackEnd["anniCompiuti"] = dati.anniCompiuti
        ObjectForBackEnd["mesiCompiuti"] = dati.mesiCompiuti
        ObjectForBackEnd["meseGestazione"] = dati.meseGestazione

        let res = Utils.removeEmptyValueFromObject(ObjectForBackEnd);
        return res;
    }

    controllaDati() {

        let dati = this.state.datiAnagraficiPaziente
        dati.corretto = []

        if (!this.props.datiPaziente.soggettoAnonimizzato) {
            if (!this.state.datiAnagraficiPaziente.cognomePaziente) dati.corretto[0] = "Campo \"Cognome\" mancante";
            if (!this.state.datiAnagraficiPaziente.nomePaziente) dati.corretto[1] = "Campo \"Nome\" mancante";
        }
        if (!this.state.datiAnagraficiPaziente.sesso) dati.corretto[2] = "Campo \"Sesso\" mancante";
        if (!this.state.datiAnagraficiPaziente.dataNascitaPaziente || (this.state.datiAnagraficiPaziente.dataNascitaPaziente && Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiAnagraficiPaziente.dataNascitaPaziente), "-"))) dati.corretto[3] = "Campo \"Data di nascita\" mancante o errato";
        if (this.state.datiAnagraficiPaziente.mesiCompiuti === "" && this.state.datiAnagraficiPaziente.anniCompiuti === "") dati.corretto[4] = "Campo \"Età\" mancante";
        if (parseInt(this.state.datiAnagraficiPaziente.anniCompiuti) < 50 && this.state.datiAnagraficiPaziente.sesso === "F" && this.state.datiAnagraficiPaziente.statoGravidanza === "") dati.corretto[5] = "Campo \"Se femmina < 50 anni di età, è in stato di gravidanza?\" mancante";
        if (this.state.datiAnagraficiPaziente.statoGravidanza === "01" && this.state.datiAnagraficiPaziente.meseGestazione === "") dati.corretto[6] = "Campo \"Se sì, mese di gestazione:\" mancante";

    }

    riceviValoreRadioButton(event, field) {
        let datiAnagraficiPaziente = this.state.datiAnagraficiPaziente
        datiAnagraficiPaziente[field] = event
        if (datiAnagraficiPaziente.statoGravidanza !== "01") {
            datiAnagraficiPaziente.meseGestazione = ""
        }
        this.setState({datiAnagraficiPaziente: datiAnagraficiPaziente})
    }

    riceviValoreInput(field, event) {

        let datiAnagraficiPaziente = this.state.datiAnagraficiPaziente
        if (field.currentTarget) {
            datiAnagraficiPaziente[field.currentTarget.id] = field.currentTarget.value
        } else {
            datiAnagraficiPaziente[field] = event.target.value
        }

        if (field === "mesiCompiuti" && datiAnagraficiPaziente.anniCompiuti) {
            datiAnagraficiPaziente.anniCompiuti = ""
        } else if (field === "anniCompiuti" && datiAnagraficiPaziente.mesiCompiuti) {
            datiAnagraficiPaziente.mesiCompiuti = ""
        }
        this.setState({datiAnagraficiPaziente: datiAnagraficiPaziente})
    }

    render() {

        const {t} = this.props

        let suggestionComuneNazione = this.state.comuni.concat(this.state.listaNazioni);

        return (<div style={{marginTop: "20px"}}>
            <div>
                <h6>{t("SchedaInfluenzaGrave.datiAnagraficiPaziente")}</h6>
                <hr className={styles.hr}/>
            </div>
            <div className={"container"}>
                <div className="row" style={{marginTop: "10px"}}>
                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                        <p className={styles.testo} style={{marginTop: "10px"}}>
                            {t("SchedaInfluenzaGrave.cognome")}
                            {!this.props.datiPaziente.soggettoAnonimizzato ?
                                <span className={styles.mandatoryColor}>*</span> : ""}
                        </p>
                        <Input id="cognomePaziente"
                               field={"cognomePaziente"}
                               value={this.state.datiAnagraficiPaziente.cognomePaziente}
                               placeholder={"Cognome"}
                               onChange={this.riceviValoreInput}
                        >
                        </Input>
                    </div>
                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                        <p className={styles.testo} style={{marginTop: "10px"}}>
                            {t("SchedaInfluenzaGrave.nome")}
                            {!this.props.datiPaziente.soggettoAnonimizzato ?
                                <span className={styles.mandatoryColor}>*</span> : ""}
                        </p>
                        <Input id="nomePaziente"
                               field={"nomePaziente"}
                               value={this.state.datiAnagraficiPaziente.nomePaziente}
                               placeholder={"Nome"}
                               onChange={this.riceviValoreInput}
                        >
                        </Input>
                    </div>
                    <div className={`col-lg-1 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                        <p className={styles.testo}>
                            {t("SchedaInfluenzaGrave.sesso")}

                        </p>
                        <div className={"row"}>
                            <RadioButton id={"sessoM"} name={t("SchedaInfluenzaGrave.sesso")} label={"M"}
                                         onClick={() => this.riceviValoreRadioButton("M", "sesso")}
                                         smallLabel={true} value={"M"}
                                         checked={this.state.datiAnagraficiPaziente.sesso === "M"}

                            />
                            <RadioButton id={"sessoF"} name={t("SchedaInfluenzaGrave.sesso")} label={"F"}
                                         onClick={() => this.riceviValoreRadioButton("F", "sesso")}
                                         smallLabel={true} value={"F"}
                                         checked={this.state.datiAnagraficiPaziente.sesso === "F"}

                            />
                        </div>
                    </div>
                    <div className="col-lg-1"/>
                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                        <div className={styles.fieldContainer}>
                            <p className={styles.testo}
                               style={{marginTop: "10px"}}>{t("SchedaInfluenzaGrave.comuneResidenza")}</p>
                            <Autocomplete id="comuneResidenza"
                                          field={"comuneResidenza"}
                                          keyField={"codice"}
                                          descriptionField={"descrizione"}
                                          suggestionField={"descrizione"}
                                          value={this.state.datiAnagraficiPaziente.comuneResidenza}
                                          placeholder={t("GestioneFocolai.informazione.comune")}
                                          suggestions={suggestionComuneNazione}
                                          onChange={this.riceviValoreInput}

                            >
                            </Autocomplete>
                        </div>
                    </div>
                </div>
                <div className="row" style={{marginTop: "10px"}}>
                    <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                        <p className={styles.testo} style={{marginTop: "10px"}}>{t("SchedaInfluenzaGrave.dataNascita")}
                            <span className={styles.mandatoryColor}>*</span></p>
                        <Calendar id="dataNascitaPaziente"
                                  field={"dataNascitaPaziente"}
                                  value={this.state.datiAnagraficiPaziente.dataNascitaPaziente}
                                  onChange={this.riceviValoreInput}
                                  errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                      "Data")}
                                  error={(this.state.datiAnagraficiPaziente.dataNascitaPaziente === "" ||
                                      this.state.datiAnagraficiPaziente.dataNascitaPaziente == null) ? false :
                                      Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiAnagraficiPaziente.dataNascitaPaziente), "-")}

                        >
                        </Calendar>
                    </div>
                    <div className="col-lg-3"/>
                    <div className="col-lg-5">
                        <div className="row">

                            <div className="col-lg-2" style={{marginTop: "50px"}}>{t("SchedaInfluenzaGrave.eta")}
                                <span className={styles.mandatoryColor}>*</span></div>
                            <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                <p className={styles.testo}
                                   style={{marginTop: "10px"}}>{t("SchedaInfluenzaGrave.anniCompiuti")}</p>
                                <Input id="anniCompiuti"
                                       field={"anniCompiuti"}
                                       value={this.state.datiAnagraficiPaziente.anniCompiuti}
                                       placeholder={"Anni"}
                                       disabled={false}
                                       onChange={this.riceviValoreInput}
                                       type={"number"}
                                       min={"0"}>
                                </Input>
                            </div>
                            {this.state.datiAnagraficiPaziente.anniCompiuti < 1 ? <>
                                <div className="col-lg-2"
                                     style={{marginTop: "50px"}}>{t("SchedaInfluenzaGrave.oppure")}</div>
                                <div className="col-lg-3">
                                    <p className={styles.testo}
                                       style={{marginTop: "10px"}}>{t("SchedaInfluenzaGrave.mesi")}</p>
                                    <Input id="mesiCompiuti"
                                           field={"mesiCompiuti"}
                                           value={this.state.datiAnagraficiPaziente.mesiCompiuti}
                                           placeholder={"Mesi"}
                                           disabled={false}
                                           onChange={this.riceviValoreInput}
                                           type={"number"}
                                           min={"0"}>
                                    </Input>
                                </div>
                            </> : null}

                        </div>
                    </div>
                </div>

                <div className="row" style={{marginTop: "10px"}}>
                    <div className="col-lg-6">
                        <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                            <b>{t("SchedaInfluenzaGrave.domanda1")}</b>
                            {(parseInt(this.state.datiAnagraficiPaziente.anniCompiuti) < 50 && this.state.datiAnagraficiPaziente.sesso === "F") ?
                                <span className={styles.mandatoryColor}>*</span> : ""}
                        </p>
                    </div>
                    <div className="col-lg-6">
                        <div className="row">
                            <RadioButton id={"statoGravidanzaSi"}
                                         name={"statoGravidanza"} label={t("SchedaEpatite.risposteTipoUno.si")}
                                         value={"01"}
                                         onClick={() => this.riceviValoreRadioButton("01", "statoGravidanza")}
                                         checked={this.state.datiAnagraficiPaziente.statoGravidanza === "01"}
                            >
                            </RadioButton>
                            <RadioButton id={"statoGravidanzaNo"}
                                         name={"statoGravidanza"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                         value={"02"}
                                         onClick={() => this.riceviValoreRadioButton("02", "statoGravidanza")}
                                         checked={this.state.datiAnagraficiPaziente.statoGravidanza === "02"}

                            />
                            <RadioButton id={"statoGravidanzaNonSo"}
                                         name={"statoGravidanza"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
                                         value={"03"}
                                         onClick={() => this.riceviValoreRadioButton("03", "statoGravidanza")}
                                         checked={this.state.datiAnagraficiPaziente.statoGravidanza === "03"}
                            />
                        </div>
                    </div>
                </div>
                <div className="row" style={{marginTop: "10px"}}>
                    <div className="col-lg-6">
                        <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                            <b>{t("SchedaInfluenzaGrave.domanda2")} {(this.state.datiAnagraficiPaziente.statoGravidanza === "01") ?
                                <span className={styles.mandatoryColor}>*</span> : <span/>}</b></p>
                    </div>
                    <div className="col-lg-2">
                        <Input id={"meseGestazione"}
                               field={"meseGestazione"}
                               value={this.state.datiAnagraficiPaziente.meseGestazione}
                               placeholder={"Mesi"}
                               disabled={this.state.datiAnagraficiPaziente.statoGravidanza !== "01"}
                               onChange={this.riceviValoreInput}
                               type={"number"}
                               min={"0"}
                               max={"9"}
                        >
                        </Input>
                    </div>
                </div>
            </div>

        </div>)
    }


}


export default withTranslation('common')(DatiAnagraficiPaziente)
